import React, { memo, useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useMediaQuery } from "@mui/material"
import dayjs from "dayjs"
import Header from "./Header"
import LeftMenu from "./LeftMenu"
import { getUser } from "../store/auth/auth.selectors"
import { actions } from "../store/auth/auth.reducers"
import { actions as dataActions } from "../store/data/data.reducers"
import { useWebSocket } from "../hooks/useWebSocket"
import { isUserSourceRestricted } from "../helpers/helpers"
import { getIsProcessPayrollStarted } from "../store/data/data.selectors"
import { fetchUserData } from "../services/userService"
import { useCan } from "../hooks/useCan"
import axios from "../axios"

// import TrialEnded from "./common/TrialEnded";

const Layout = ({ children, pathname }) => {
  const dispatch = useDispatch()
  const nav = useNavigate()
  const userData = useSelector(getUser)
  const isProcessPayrollStartedFromRedux = useSelector(getIsProcessPayrollStarted)
  const userSavedData = localStorage.getItem("user")

  const isMobile = useMediaQuery("(max-width:990px)")
  const isCollapsedFromStorage = localStorage.getItem("isMenuCollapsed")
  const isProcessPayrollStarted = localStorage.getItem("isProcessPayrollStarted")
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [isOpen, setIsOpen] = useState(false)

  const isUserRestricted = isUserSourceRestricted()
  const canManageSettings = useCan("settings.view");

  useEffect(() => {
    if (!isMobile && isCollapsedFromStorage) {
      const isCollapsedFromStorageToBool = isCollapsedFromStorage !== "false"
      dispatch(dataActions.setIsCollapsed(isCollapsedFromStorageToBool))
      setIsCollapsed(isCollapsedFromStorageToBool)
    }
  }, [])

  useEffect(() => {
    if (Object.keys(userData).length === 0) {
      fetchUserData()
      .then((response) => {
        if (response?.companies_count === 0) {
          nav("/onboard-company")
        }
      })
      .catch((err) => {
        console.error("Error fetching user:", err);
      });
    } else if (Object.keys(JSON.parse(userSavedData || "{}")).length !== 0) {
      dispatch(actions.loginUser(JSON.parse(userSavedData || "{}")))
    } else if (userData.companies_count === 0) {
      nav("/onboard-company")
      return
    }
  }, [])

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (!isUserRestricted) {
        window.Intercom("boot", {
          app_id: "dyklmyeq",
          name: `${userData.first_name || ""} ${userData.last_name || ""}`.trim(),
          email: userData.email,
          user_id: userData.id,
          user_hash: userData.hmac,
          created_at: userData.created_at,
          company: {
            company_id: userData.organization_id,
            name: userData.organization?.name
          }
        })
      }
    }
  }, [userData])

  const { echo } = useWebSocket(
    userData,
    JSON.parse(isProcessPayrollStarted || "{}") || isProcessPayrollStartedFromRedux
  )

  const isSubscribedKeyExisting = Object.keys(userData).includes("is_subscribed")
  const isCompanySubscribed = userData.is_subscribed
  const trialDaysDiff = Math.ceil(dayjs(userData.subscription_ends_at).diff(dayjs(), "hours") / 24)
  const isShowTrial = !isCompanySubscribed && trialDaysDiff <= 5
  const isTrialEnded = userData.is_trial_expired || trialDaysDiff < 1
  const isPastDue = userData.is_past_due

  const handleAddInfo = () => nav("/settings?page=subscription&add_info_trial=true")
  // const handleCheckInfo = () => nav("/settings?page=subscription");

  useEffect(() => {
    if (userData && userData.companies_count === 0) {
      nav("/onboard-company")
    }
  }, [pathname, userData])

  let message

  const handleManageBilling = () => {
    axios
      .post("/subscription/create-portal-session")
      .then((response) => {
        if (response.success) {
          window.location.href = response.data.url
        }
      })
      .catch((err) => {
        console.error("Error creating portal session:", err)
        nav("/settings?page=subscription")
      })
  }

  if (isPastDue) {
    message = (
      <div className="trial-wrapper">
        Your subscription is paused.

        {
          canManageSettings ? (
            <>
              Please, check your payment details or{" "}
              <span className="check-payment-button" onClick={handleManageBilling}>
                update your payment method
              </span>
            </>
          ) : 'Contact your administrator'
        }
        .
      </div>
    )
  } else if (isShowTrial && isSubscribedKeyExisting) {
    message = (
      <div className="trial-wrapper">
        {isTrialEnded ? (
          "The trial period is ended."
        ) : (
          <>
            The trial period is ending in <b>{trialDaysDiff} days.</b>
          </>
        )}{" "}

        {
          canManageSettings ? (
            <>
              Please provide your information to continue using the service!{" "}

              <div className="trial-button" onClick={handleAddInfo}>
                Add information
              </div>
            </>
          ) : 'Please contact your administrator'
        }
      </div>
    )
  }

  return (
    <div className="main-outer-sec">
      <LeftMenu
        setIsCollapsed={setIsCollapsed}
        isCollapsed={isCollapsed}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <div
        className="content-sec scrollbar"
        style={{
          width:
            isCollapsed && !isMobile
              ? "calc(100% - 100px)"
              : isMobile
                ? "100%"
                : "calc(100% - 200px)"
        }}>
        <Header isOpen={isOpen} setIsOpen={setIsOpen} />
        {!isUserRestricted && message}
        {/* {!isCompanySubscribed && isTrialEnded && isWageCalculatorPage && isSubscribedKeyExisting ? (
          <TrialEnded onClick={handleAddInfo} />
        ) : ( */}
        {React.cloneElement(children, { echo: echo })}
        {/* )} */}
      </div>
    </div>
  )
}

export default memo(Layout)
